export default __webpack_public_path__ + "static/media/token_commit.455d13d2.png";